import { Button, Modal } from "@scuf/common";
import { uploadValidationPopupEvent } from "../../../../../../common/utility/dataManagementUtils";

export const FileValidatePopup = (props: any) => {
  const {
    uploadValidateOpen,
    setUploadValidateOpen,
    uploadFile,
    resetFileInput,
    rowKey,
    setFileNameUpload,
  } = props;

  return (
    <Modal
      className="modal-content-dataManagement-wrapper"
      open={uploadValidateOpen}
      onClose={() => setUploadValidateOpen(false)}
      closeOnDimmerClick={false}
      closeOnDocumentClick={false}
    >
      <Modal.Content className="modal-content-dataManagement">
        <span className="modal-text-dataManagement">
          File name already exists. Please use a different file name.
        </span>
      </Modal.Content>
      <Modal.Footer className="modal-footer-dataManagement">
        {/* <Button
          type="secondary"
          size="small"
          content="Cancel"
          onClick={(e: any) =>
            uploadValidationPopupEvent(
              e,
              resetFileInput,
              rowKey,
              setUploadValidateOpen,
              setFileNameUpload
            )
          }
          className="cancel-secondary-dataManagement"
        /> */}
        <Button
          type="primary"
          size="small"
          content="Ok"
          onClick={(e: any) =>
            uploadValidationPopupEvent(
              e,
              resetFileInput,
              rowKey,
              setUploadValidateOpen,
              setFileNameUpload
            )
          }
          className="save-secondary-dataManagement"
        />
      </Modal.Footer>
    </Modal>
  );
};
